import React from "react"

import { graphql, useStaticQuery } from "gatsby"
import PropTypes from "prop-types"

import * as styles from "./newsletter-question.module.scss"
import Button from "../../atoms/button"
import CopyContainer from "../../atoms/copy-container"
import Heading from "../../atoms/heading"
import NewsletterPartner from "../newsletter-partner"

const NewsletterQuestion = ({ section }) => {
  const { allSanityDictionary } = useStaticQuery(graphql`
    {
      allSanityDictionary {
        nodes {
          key {
            current
          }
          value
        }
      }
    }
  `)
  return (
    <div className={styles.wrapper}>
      <div className={styles.heading}>
        <Heading level={4} className={styles.title}>
          {section.title}
        </Heading>
        <NewsletterPartner
          section={section}
          dictionary={allSanityDictionary.nodes}
        />
      </div>
      <CopyContainer content={section._rawContent} />
      {section.options?.length > 0 ? (
        <div className={styles.options}>
          {section.options.map((option) => (
            <Button
              variant="secondary"
              className={styles.option}
              url={`${section.page ? `/page/${section.page.slug.current}` : "/poll"}?poll_id=${section.poll_id}&answer=${option}`}
            >
              {option}
            </Button>
          ))}
        </div>
      ) : (
        ""
      )}
    </div>
  )
}

export default NewsletterQuestion

NewsletterQuestion.propTypes = {
  section: PropTypes.object.isRequired,
}
